"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SLA_SENT_ORDERS_UNCONFIRMED_OPTIONS = exports.SLA_SENT_ORDERS_DELIVERY_OPTIONS = exports.FILTER_FORM_SETTINGS = exports.TRANSACTION_TYPE_OPTIONS = exports.GROUP_ITEM_BY = exports.SLA_OPTIONS = exports.EDITING_STATUS_OPTIONS = exports.ESCALATION_OPTIONS_DESCRIPTION = exports.ESCALATION_OPTIONS = exports.GROUP_TIME_BY_OPTIONS_WITHOUT_TOTAL = exports.GROUP_TIME_BY_OPTIONS = exports.GROUP_BY_ITEM_OPTIONS = exports.GROUP_TIME_BY_OPTIONS_WITH_HOURS = exports.UPPER_FILTERS_ALLOWED_TABS = exports.FILTER_URLS = exports.FILTER_DEFAULTS = exports.DELAYED_FILTER_DEFAULTS = exports.COMMON_FILTER_DEFAULTS = exports.FILTER_TYPE = exports.FILTER_FIELD = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _dateTypes = require("./dateTypes");

var _reportConsts = require("./reportConsts");

var _orderStatuses = require("./orderStatuses");

var _config = require("../config");

var _Utils = _interopRequireDefault(require("../utils/Utils"));

var _objectSpread2, _objectSpread3, _objectSpread4, _objectSpread5, _objectSpread7, _objectSpread21, _FILTER_DEFAULTS;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defaultCurrency = _config.Config.get('settings', 'defaultCurrency'); // TODO: remove FILTER_COLUMN_TYPE constant, use only this.


var FILTER_FIELD = {
  ARTICLE_COLOR: 'articleColor',
  ARTICLE_ID: 'articleId',
  ARTICLE_ID_OR_EAN: 'articleIdOrEan',
  ARTICLE_WARNING_ID: 'articleWarningId',
  BRAND_ID: 'brandId',
  BRAND_NAME: 'brandName',
  CHANNEL_HJID: 'channelHjid',
  CHANNEL_ID: 'channelId',
  CHAN_ORD_REF: 'chanOrdRef',
  COUNTING_MODE: 'countingMode',
  CURRENCY: 'currency',
  EAN: 'ean',
  EAN_OR_PRODUCT_ID_TYPE: 'eanOrProductId',
  EMAIL_REPORT_TYPE: "emailReportType",
  EMAIL_SETTINGS_TYPE_ID: 'emailSettingsTypeId',
  EMAIL_SUBJECT: "emailSubject",
  ESCALATION: 'escalation',
  FROM_DATE: 'fromDate',
  GROUP_BAR_BY: 'groupBarBy',
  GROUP_ITEM_BY: 'groupItemBy',
  GROUP_TIME_BY: 'groupTimeBy',
  HAS_SINGLE_ITEM: 'hasSingleItem',
  INVOICE_ID: 'invoiceId',
  IS_SOLVED: 'isSolved',
  LANGUAGE: 'language',
  NOTIFICATION_TYPE_ID: 'notificationTypeId',
  ORDER_ID: 'orderId',
  ORDER_REFERENCE_FULFILMENT: 'orderReferenceFulfilment',
  ORDER_STATUS: 'orderStatus',
  OWNER_PARTNER_ID: 'ownerPartner',
  PARTNER_ARTICLE_ID: 'partnerArticleId',
  PARTNER_EMULATION_ID: 'partnerEmulationId',
  PARTNER_ID: 'partnerId',
  PARTNER_PRODUCT_ID: 'partnerProductId',
  PAYMENT_ID: "paymentId",
  PRODUCT_ID: 'productId',
  PRODUCT_ID_OR_PARTNER_PRODUCT_ID: 'productIdOrPartnerProductId',
  REASONS: 'reasons',
  REPORT_TYPE: 'reportType',
  RETURN_CONDITION: 'returnConditions',
  SALES_REPORT_TYPE: 'salesReportType',
  SEASON: 'season',
  SERVED_PARTNER_ID: 'servedPartner',
  SLA_CATALOG: 'catalogSLA',
  START_HUB: "startHub",
  STATUS: 'status',
  TARGET_HUB: "targetHub",
  TO_DATE: 'toDate',
  TYPE: "type",
  USER_ID: 'userId',
  WAREHOUSE_ID: 'warehouseId',
  RETURN_WAREHOUSE_ID: 'returnWarehouseId',
  WARNING_CREATION_DATA: 'warningCreationDate',
  WARNING_ID: "warningId",
  WARNING_LAST_DATE_APPEARED: 'warningLastDateAppeared',
  WARNING_LEVEL: "warningLevel",
  WARNING_REPORT_TYPE: "warningReportType",
  WARNING_TYPE: "warningType",
  TRACKING_CODE: "trackingCode",
  RETURN_TRACKING_CODE: "returnTrackingCode",
  FIRST_DELIVERY_APPROACH: "firstDeliveryApproach",
  CARRIER_SLA: 'carrierSla',
  PICK_UP_SLA: 'pickupSla'
};
exports.FILTER_FIELD = FILTER_FIELD;
var FILTER_TYPE = {
  ARCHIVED_ARTICLES: 'archivedArticles',
  ARTICLES_CREATION: 'ARTICLES_CREATION',
  BLOCKED_FULL: 'blockedFull',
  BUSINESS_SUMMARY_ALL_WARNINGS: 'businessSummaryAllWarnings',
  BUSINESS_SUMMARY_HISTORY_EMAIL_WARNINGS: 'businessSummaryEmailWarnings',
  BUSINESS_SUMMARY_MESSAGES: 'BUSINESS_SUMMARY_MESSAGES',
  BUSINESS_SUMMARY_SOLUTIONS: 'BUSINESS_SUMMARY_SOLUTIONS',
  CANCELLED_ALERTS: 'cancelledOrdersAlerts',
  CANCELLED_CHART: 'cancelledOrdersChart',
  CANCELLED_CUMULATIVE: 'cancelledOrdersCumulative',
  CANCELLED_FULL: 'cancelledOrdersFull',
  COCKPIT_CANCELLATIONS_GRAPH: 'cockpitCancellationsGraph',
  COCKPIT_SLA_FAIL_GRAPH: 'cockpitSlaFailGraph',
  COMMON_ORDERS_CHART: 'commonOrdersChart',
  COMMON_ORDERS_CONFIRMATION: 'commonOrdersConfirmation',
  COMMON_ORDERS_CUMULATIVE: 'commonOrdersCumulative',
  COMMON_ORDERS_FULL: 'commonOrdersFull',
  COMMON_ORDERS_SECONDARY_CHART: 'commonOrdersSecondaryChart',
  COMMON_ORDERS_SECONDARY_CUMULATIVE: 'commonOrdersSecondaryCumulative',
  COMMON_ORDERS_SECONDARY_FULL: 'commonOrdersSecondaryFull',
  CURRENCY_FILTER: 'currencyFilter',
  DELAYED_CHART: 'delayedChart',
  DELAYED_CUMULATIVE: 'delayedCumulative',
  DELAYED_FULL: 'delayedFull',
  EMAIL_SETTINGS: 'emailSettings',
  FIRST_FULL: 'firstFull',
  HEADER_FILTER: 'headerFilter',
  HISTORY_INVOICE_FULL: 'historyInvoiceFull',
  LACKING_TC_CUMULATIVE: 'lackingTCOrdersCumulative',
  LACKING_TC_FULL: 'lackingTCOrdersFull',
  MEDIA_WARNINGS_WITH_CATEGORY: 'warningsWithCategory',
  MEDIA_BLOCKED_GRAPH: 'MEDIA_BLOCKED_GRAPH',
  MEDIA_HISTORY_EMAIL_WARNINGS: 'mediaEmailWarnings',
  MEDIA_MESSAGES: 'MEDIA_MESSAGES',
  MEDIA_SELF_DATA: 'MEDIA_SELF_DATA',
  MEDIA_SOLUTIONS: 'MEDIA_SOLUTIONS',
  MISSING_IDENT_CODE_FULL: 'missingIdentCodeFull',
  OPENED_CHART: 'openedChart',
  OPENED_CONFIRMATION: 'openedConfirmation',
  OPENED_CUMULATIVE: 'openedCumulative',
  OPENED_FULL: 'openedFull',
  OPENED_INVOICE_FULL: 'openedInvoiceFull',
  SENT_ORDER_UNCONFIRMED_WITH_CARRIER: 'sentOrderUnconfirmedWithCarrier',
  SENT_ORDER_DELIVERY_PROGRESS: 'sentOrderDeliveryProgress',
  OPEN_TASK_HISTORY_LINE_CHART: 'openTaskHistoryLineChart',
  OPEN_TASK_HISTORY_PIE_CHART: 'openTaskHistoryPieChart',
  ORDER_STATISTICS: 'orderStatistics',
  ORDER_STATISTICS_CANCELLATIONS: 'orderStatisticsCancellations',
  ORDER_STATISTICS_CONFIRMED: 'orderStatisticsConfirmed',
  ORDER_STATISTICS_RETURNS: 'orderStatisticsReturns',
  ORDER_STATISTICS_SHIPMENTS: 'orderStatisticsShipments',
  OVER_SALES_FULL: 'oversalesFull',
  PAYMENT_SUMMARY: 'paymentSummary',
  PAYMENT_TRANSACTIONS: 'paymentTransactions',
  PENDING_CHART: 'pendingChart',
  PENDING_CUMULATIVE: 'pendingCumulative',
  PENDING_FULL: 'pendingFull',
  PRICE_VALIDATION_FULL: 'priceValidationFull',
  PRODUCT_DATA_ALL_WARNINGS: 'productDataAllWarnings',
  PRODUCT_DATA_HISTORY_EMAIL_WARNINGS: 'productDataEmailWarnings',
  PRODUCT_DATA_MESSAGES: 'PRODUCT_DATA_MESSAGES',
  PRODUCT_DATA_OVERVIEW: 'PRODUCT_DATA_OVERVIEW',
  PRODUCT_DATA_OVERVIEW_GRAPH: 'productDataOverviewGraph',
  PRODUCT_DATA_SOLUTIONS: 'PRODUCT_DATA_SOLUTIONS',
  PRODUCT_STATUS_ALL_WARNINGS: 'productStatusAllWarnings',
  PRODUCT_STATUS_CUMULATIVE: 'productStatusCumulative',
  PRODUCT_STATUS_EMAIL_WARNINGS: 'productStatusEmailWarnings',
  PRODUCT_STATUS_FULL: 'productStatusFull',
  PRODUCT_STATUS_HISTORY_EMAIL_WARNINGS: 'productStatusHistoryEmailWarnings',
  PRODUCT_STATUS_LINE_CHART: 'productStatusLineChart',
  PRODUCT_STATUS_OVERVIEW: 'productStatusOverview',
  PRODUCT_STATUS_PIE_CHART: 'productStatusPieChart',
  RETURNED_CHART: 'returnedChart',
  RETURNED_CUMULATIVE: 'returnedCumulative',
  RETURNED_FULL: 'returnedFull',
  RETURNED_OPEN: 'returnedOpen',
  SALES_DASHBOARD: 'SALES_DASHBOARD',
  SLA_BY_DELIVERY: 'slaDelivery',
  SLA_CUMULATIVE: 'slaCumulative',
  SLA_CUMULATIVE_BY_DELIVERY: 'slaCumulativeByDeliveryOrders',
  SLA_CUMULATIVE_BY_SHIPMENT: 'slaCumulativeByShipmentOrders',
  SLA_GRAPH: 'slaGraphsFilter',
  SLA_HANDOVER_HISTORY: 'slaHandoverHistory',
  SLA_HISTORY_SHIPMENT: 'slaHistoryShipmentOrders',
  SLA_PARCEL_HISTORY: 'slaParcelHistory',
  SUMMARY_WAREHOUSE_CHART: 'summaryWarehouseChart',
  SUMMARY_WAREHOUSE_CUMULATIVE: 'summaryWarehouseCumulative',
  TEMPLATE_OPTIONS_FILTER: 'LANGUAGE_FILTER',
  USER_PERMISSIONS: 'userPermissions',
  VALUE_GROUP_ANALYSIS: 'valueGroupAnalysis',
  TEMPLATE_ANALYSIS: 'templateAnalysis',
  TEMPLATE_ANALYSIS_OVERVIEW: 'TEMPLATE_ANALYSIS_OVERVIEW',
  TEMPLATE_ANALYSIS_PARTNER_DETAILS: 'TEMPLATE_ANALYSIS_PARTNER_DETAILS',
  COMMON_ORDERS_DATES: 'ordersDates',
  COCKPIT_CHANNEL_SLA_1W: "COCKPIT_CHANNEL_SLA_1W",
  COCKPIT_CHANNEL_SLA_4W: "COCKPIT_CHANNEL_SLA_4W",
  COCKPIT_CHANNEL_SLA_12W: "COCKPIT_CHANNEL_SLA_12W"
};
exports.FILTER_TYPE = FILTER_TYPE;
var COMMON_FILTER_DEFAULTS = {
  fromDate: (0, _moment["default"])().startOf("month").format(_dateTypes.DATE_TIME_TYPE),
  toDate: (0, _moment["default"])().endOf('day').format(_dateTypes.DATE_TIME_TYPE)
};
exports.COMMON_FILTER_DEFAULTS = COMMON_FILTER_DEFAULTS;
var DELAYED_FILTER_DEFAULTS = {
  fromDate: (0, _moment["default"])().startOf("month").format(_dateTypes.DATE_TIME_TYPE),
  toDate: (0, _moment["default"])().endOf('day').format(_dateTypes.DATE_TIME_TYPE)
};
exports.DELAYED_FILTER_DEFAULTS = DELAYED_FILTER_DEFAULTS;
var FILTER_DEFAULTS = (_FILTER_DEFAULTS = {
  commonOrders: COMMON_FILTER_DEFAULTS
}, _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.COMMON_ORDERS_CUMULATIVE, COMMON_FILTER_DEFAULTS), _defineProperty(_FILTER_DEFAULTS, "commonOrdersSecondaryCumulative", COMMON_FILTER_DEFAULTS), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.COMMON_ORDERS_FULL, COMMON_FILTER_DEFAULTS), _defineProperty(_FILTER_DEFAULTS, "commonOrdersSecondaryFull", COMMON_FILTER_DEFAULTS), _defineProperty(_FILTER_DEFAULTS, "commonOrdersChart", COMMON_FILTER_DEFAULTS), _defineProperty(_FILTER_DEFAULTS, "commonOrdersConfirmation", {
  fromDate: (0, _moment["default"])().subtract(7, "day").startOf("day").format(_dateTypes.DATE_TIME_TYPE),
  toDate: (0, _moment["default"])().endOf('day').format(_dateTypes.DATE_TIME_TYPE),
  currency: defaultCurrency,
  groupTimeBy: 'hourly'
}), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.COCKPIT_SLA_FAIL_GRAPH, {
  fromDate: (0, _moment["default"])().subtract(30, "day").startOf("day").format(_dateTypes.DATE_TIME_TYPE),
  toDate: (0, _moment["default"])().endOf('day').format(_dateTypes.DATE_TIME_TYPE),
  groupItemBy: 'partner'
}), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.COCKPIT_CHANNEL_SLA_1W, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  weeks: 1
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.COCKPIT_CHANNEL_SLA_4W, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  weeks: 4
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.COCKPIT_CHANNEL_SLA_12W, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  weeks: 12
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.COCKPIT_CANCELLATIONS_GRAPH, {
  fromDate: (0, _moment["default"])().subtract(30, "day").startOf("day").format(_dateTypes.DATE_TIME_TYPE),
  toDate: (0, _moment["default"])().endOf('day').format(_dateTypes.DATE_TIME_TYPE),
  groupItemBy: 'partner'
}), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.SALES_DASHBOARD, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  currency: 'EUR',
  groupItemBy: 'article',
  groupTimeBy: 'daily'
})), _defineProperty(_FILTER_DEFAULTS, "orderStatisticsStatus", {
  orderStatus: _orderStatuses.ORDER_STATUS_CONFIRMED
}), _defineProperty(_FILTER_DEFAULTS, "salesDashboard", _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  currency: defaultCurrency,
  groupTimeBy: 'daily',
  groupItemBy: 'product'
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.DELAYED_CUMULATIVE, _objectSpread({}, DELAYED_FILTER_DEFAULTS, {
  reportType: _reportConsts.REPORT_TYPE.DELAYED_CUMULATIVE
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.DELAYED_FULL, _objectSpread({}, DELAYED_FILTER_DEFAULTS, {
  reportType: _reportConsts.REPORT_TYPE.DELAYED_FULL
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.DELAYED_CHART, _objectSpread({}, DELAYED_FILTER_DEFAULTS, {
  reportType: _reportConsts.REPORT_TYPE.DELAYED_FULL
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.SENT_ORDER_UNCONFIRMED_WITH_CARRIER, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  reportType: _reportConsts.REPORT_TYPE.SENT_ORDER_UNCONFIRMED_WITH_CARRIER
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.SENT_ORDER_DELIVERY_PROGRESS, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  reportType: _reportConsts.REPORT_TYPE.SENT_ORDER_DELIVERY_PROGRESS
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.OPENED_CUMULATIVE, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  reportType: _reportConsts.REPORT_TYPE.OPENED_CUMULATIVE
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.OPENED_FULL, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  reportType: _reportConsts.REPORT_TYPE.OPENED_FULL
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.OPENED_CHART, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  reportType: _reportConsts.REPORT_TYPE.OPENED_FULL
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.OPENED_CONFIRMATION, {
  fromDate: (0, _moment["default"])().subtract(7, "day").startOf("day").format(_dateTypes.DATE_TIME_TYPE),
  toDate: (0, _moment["default"])().endOf('day').format(_dateTypes.DATE_TIME_TYPE),
  currency: defaultCurrency,
  groupTimeBy: 'hourly',
  reportType: _reportConsts.REPORT_TYPE.OPENED_CONFIRMATION
}), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.PENDING_CUMULATIVE, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  reportType: _reportConsts.REPORT_TYPE.PENDING_CUMULATIVE
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.PENDING_FULL, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  reportType: _reportConsts.REPORT_TYPE.PENDING_FULL
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.PENDING_CHART, COMMON_FILTER_DEFAULTS), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.ORDER_STATISTICS_CONFIRMED, _objectSpread({}, COMMON_FILTER_DEFAULTS, (_objectSpread2 = {}, _defineProperty(_objectSpread2, FILTER_FIELD.FROM_DATE, (0, _moment["default"])().startOf("month").format(_dateTypes.DATE_TIME_TYPE)), _defineProperty(_objectSpread2, FILTER_FIELD.TO_DATE, (0, _moment["default"])().endOf('day').format(_dateTypes.DATE_TIME_TYPE)), _defineProperty(_objectSpread2, FILTER_FIELD.CURRENCY, defaultCurrency), _defineProperty(_objectSpread2, FILTER_FIELD.GROUP_TIME_BY, 'daily'), _defineProperty(_objectSpread2, FILTER_FIELD.ORDER_STATUS, _orderStatuses.ORDER_STATUS_CONFIRMED), _defineProperty(_objectSpread2, FILTER_FIELD.SALES_REPORT_TYPE, _reportConsts.SALES_REPORT_TYPE.ORDER_STATISTICS_ORDERS), _objectSpread2))), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.ORDER_STATISTICS_SHIPMENTS, _objectSpread({}, COMMON_FILTER_DEFAULTS, (_objectSpread3 = {}, _defineProperty(_objectSpread3, FILTER_FIELD.FROM_DATE, (0, _moment["default"])().startOf("month").format(_dateTypes.DATE_TIME_TYPE)), _defineProperty(_objectSpread3, FILTER_FIELD.TO_DATE, (0, _moment["default"])().endOf('day').format(_dateTypes.DATE_TIME_TYPE)), _defineProperty(_objectSpread3, FILTER_FIELD.CURRENCY, defaultCurrency), _defineProperty(_objectSpread3, FILTER_FIELD.GROUP_TIME_BY, 'daily'), _defineProperty(_objectSpread3, FILTER_FIELD.SALES_REPORT_TYPE, _reportConsts.SALES_REPORT_TYPE.ORDER_STATISTICS_SHIPMENTS), _objectSpread3))), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.ORDER_STATISTICS_CANCELLATIONS, _objectSpread({}, COMMON_FILTER_DEFAULTS, (_objectSpread4 = {}, _defineProperty(_objectSpread4, FILTER_FIELD.FROM_DATE, (0, _moment["default"])().startOf("month").format(_dateTypes.DATE_TIME_TYPE)), _defineProperty(_objectSpread4, FILTER_FIELD.TO_DATE, (0, _moment["default"])().endOf('day').format(_dateTypes.DATE_TIME_TYPE)), _defineProperty(_objectSpread4, FILTER_FIELD.CURRENCY, defaultCurrency), _defineProperty(_objectSpread4, FILTER_FIELD.GROUP_TIME_BY, 'daily'), _defineProperty(_objectSpread4, FILTER_FIELD.SALES_REPORT_TYPE, _reportConsts.SALES_REPORT_TYPE.ORDER_STATISTICS_CANCELLATIONS), _objectSpread4))), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.ORDER_STATISTICS_RETURNS, _objectSpread({}, COMMON_FILTER_DEFAULTS, (_objectSpread5 = {}, _defineProperty(_objectSpread5, FILTER_FIELD.FROM_DATE, (0, _moment["default"])().startOf("month").format(_dateTypes.DATE_TIME_TYPE)), _defineProperty(_objectSpread5, FILTER_FIELD.TO_DATE, (0, _moment["default"])().endOf('day').format(_dateTypes.DATE_TIME_TYPE)), _defineProperty(_objectSpread5, FILTER_FIELD.CURRENCY, defaultCurrency), _defineProperty(_objectSpread5, FILTER_FIELD.GROUP_TIME_BY, 'daily'), _defineProperty(_objectSpread5, FILTER_FIELD.SALES_REPORT_TYPE, _reportConsts.SALES_REPORT_TYPE.ORDER_STATISTICS_RETURNS), _objectSpread5))), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.LACKING_TC_CUMULATIVE, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  reportType: _reportConsts.REPORT_TYPE.LACKING_TC_CUMULATIVE
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.LACKING_TC_FULL, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  reportType: _reportConsts.REPORT_TYPE.LACKING_TC_FULL
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.MISSING_IDENT_CODE_FULL, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  reportType: _reportConsts.REPORT_TYPE.MISSING_IDENT_CODE_FULL
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.FIRST, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  reportType: _reportConsts.REPORT_TYPE.FIRST
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.FIRST_FULL, _objectSpread({}, COMMON_FILTER_DEFAULTS, _defineProperty({}, FILTER_FIELD.REPORT_TYPE, _reportConsts.REPORT_TYPE.FIRST_FULL))), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.CANCELLED_CUMULATIVE, _objectSpread({}, COMMON_FILTER_DEFAULTS, (_objectSpread7 = {}, _defineProperty(_objectSpread7, FILTER_FIELD.REPORT_TYPE, _reportConsts.REPORT_TYPE.CANCELLED_CUMULATIVE), _defineProperty(_objectSpread7, FILTER_FIELD.GROUP_TIME_BY, 'total'), _objectSpread7))), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.CANCELLED_FULL, _objectSpread({}, COMMON_FILTER_DEFAULTS, _defineProperty({}, FILTER_FIELD.REPORT_TYPE, _reportConsts.REPORT_TYPE.CANCELLED_FULL))), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.CANCELLED_ALERTS, _objectSpread({}, COMMON_FILTER_DEFAULTS, _defineProperty({}, FILTER_FIELD.REPORT_TYPE, _reportConsts.REPORT_TYPE.CANCELLED_ALERT))), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.SLA_CUMULATIVE, _objectSpread({}, COMMON_FILTER_DEFAULTS, _defineProperty({}, FILTER_FIELD.REPORT_TYPE, _reportConsts.REPORT_TYPE.SLA_CUMULATIVE))), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.SLA_CUMULATIVE_BY_DELIVERY, _objectSpread({}, COMMON_FILTER_DEFAULTS, _defineProperty({}, FILTER_FIELD.REPORT_TYPE, _reportConsts.REPORT_TYPE.SLA_CUMULATIVE_BY_DELIVERY))), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.SLA_CUMULATIVE_BY_SHIPMENT, {
  fromDate: (0, _moment["default"])().startOf('month').format(_dateTypes.DATE_TIME_TYPE),
  toDate: (0, _moment["default"])().endOf('day').format(_dateTypes.DATE_TIME_TYPE),
  reportType: _reportConsts.REPORT_TYPE.SLA_CUMULATIVE
}, _defineProperty({}, FILTER_FIELD.REPORT_TYPE, _reportConsts.REPORT_TYPE.SLA_CUMULATIVE)), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.SLA_HISTORY_SHIPMENT, _objectSpread({}, COMMON_FILTER_DEFAULTS, _defineProperty({}, FILTER_FIELD.REPORT_TYPE, _reportConsts.REPORT_TYPE.SLA_FULL))), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.SLA_BY_DELIVERY, _objectSpread({}, COMMON_FILTER_DEFAULTS, _defineProperty({}, FILTER_FIELD.REPORT_TYPE, _reportConsts.REPORT_TYPE.SLA_BY_DELIVERY))), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.SLA_HANDOVER_HISTORY, _objectSpread({}, COMMON_FILTER_DEFAULTS, _defineProperty({}, FILTER_FIELD.REPORT_TYPE, _reportConsts.REPORT_TYPE.HANDOVER_HISTORY_FULL))), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.SLA_PARCEL_HISTORY, _objectSpread({}, COMMON_FILTER_DEFAULTS, _defineProperty({}, FILTER_FIELD.REPORT_TYPE, _reportConsts.REPORT_TYPE.PARCEL_HISTORY_FULL))), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.SLA_GRAPH, {
  fromDate: (0, _moment["default"])().startOf('month').format(_dateTypes.DATE_TIME_TYPE),
  toDate: (0, _moment["default"])().endOf('day').format(_dateTypes.DATE_TIME_TYPE)
}), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.RETURNED_CUMULATIVE, _objectSpread({}, COMMON_FILTER_DEFAULTS, _defineProperty({}, FILTER_FIELD.REPORT_TYPE, _reportConsts.REPORT_TYPE.RETURNED_CUMULATIVE))), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.RETURNED_FULL, _objectSpread({}, COMMON_FILTER_DEFAULTS, _defineProperty({}, FILTER_FIELD.REPORT_TYPE, _reportConsts.REPORT_TYPE.RETURNED_FULL))), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.RETURNED_CHART, _objectSpread({}, COMMON_FILTER_DEFAULTS)), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.RETURNED_OPEN, _objectSpread({}, COMMON_FILTER_DEFAULTS, _defineProperty({}, FILTER_FIELD.REPORT_TYPE, _reportConsts.REPORT_TYPE.OPEN_RETURN_FULL))), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.BLOCKED_FULL, _objectSpread({}, COMMON_FILTER_DEFAULTS, _defineProperty({}, FILTER_FIELD.REPORT_TYPE, _reportConsts.REPORT_TYPE.BLOCKED_FULL))), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.OVER_SALES_FULL, _objectSpread({}, COMMON_FILTER_DEFAULTS, _defineProperty({}, FILTER_FIELD.REPORT_TYPE, _reportConsts.REPORT_TYPE.OVERSALES_FULL))), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.PRICE_VALIDATION_FULL, _objectSpread({}, COMMON_FILTER_DEFAULTS, _defineProperty({}, FILTER_FIELD.REPORT_TYPE, _reportConsts.REPORT_TYPE.PRICE_VALIDATION_FULL))), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.PRODUCT_STATUS_CUMULATIVE, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  reportType: _reportConsts.REPORT_TYPE.PRODUCT_STATUS_CUMULATIVE
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.PRODUCT_STATUS_LINE_CHART, _defineProperty({
  fromDate: (0, _moment["default"])().subtract(30, "day").startOf("day").format(_dateTypes.DATE_TIME_TYPE),
  toDate: (0, _moment["default"])().endOf('day').format(_dateTypes.DATE_TIME_TYPE),
  reportType: _reportConsts.REPORT_TYPE.PRODUCT_STATUS_GRAPH
}, FILTER_FIELD.GROUP_TIME_BY, 'daily')), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.OPEN_TASK_HISTORY_LINE_CHART, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  reportType: _reportConsts.REPORT_TYPE.PRODUCT_STATUS_HISTORY_GRAPH
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.PRODUCT_STATUS_FULL, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  reportType: _reportConsts.REPORT_TYPE.PRODUCT_STATUS_FULL
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.PRODUCT_DATA_OVERVIEW, {
  reportType: _reportConsts.REPORT_TYPE.PRODUCT_STATUS_OVERVIEW
}), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.PRODUCT_STATUS_OVERVIEW, {
  reportType: _reportConsts.REPORT_TYPE.PRODUCT_STATUS_OVERVIEW
}), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.PRODUCT_DATA_OVERVIEW_GRAPH, {
  reportType: _reportConsts.REPORT_TYPE.PRODUCT_STATUS_OVERVIEW_GRAPH
}), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.PRODUCT_STATUS_EMAIL_WARNINGS, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  reportType: _reportConsts.REPORT_TYPE.PRODUCT_STATUS_EMAIL_WARNINGS
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.PRODUCT_STATUS_HISTORY_EMAIL_WARNINGS, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  reportType: _reportConsts.REPORT_TYPE.PRODUCT_HISTORY_EMAIL_WARNINGS
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.PRODUCT_STATUS_ALL_WARNINGS, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  reportType: _reportConsts.REPORT_TYPE.PRODUCT_STATUS_ALL_WARNINGS
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.ARCHIVED_ARTICLES, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  fromDate: (0, _moment["default"])().startOf("year").format(_dateTypes.DATE_TIME_TYPE),
  toDate: (0, _moment["default"])().endOf('day').format(_dateTypes.DATE_TIME_TYPE),
  reportType: _reportConsts.REPORT_TYPE.ARCHIVED_WARNINGS_WITH_CATEGORY
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.MEDIA_HISTORY_EMAIL_WARNINGS, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  fromDate: (0, _moment["default"])().startOf("year").format(_dateTypes.DATE_TIME_TYPE),
  toDate: (0, _moment["default"])().endOf('day').format(_dateTypes.DATE_TIME_TYPE),
  reportType: _reportConsts.REPORT_TYPE.WARNINGS_WITH_CATEGORY,
  warningCategoryReportType: 'LIB.6328886.816.1240045.175'
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.MEDIA_WARNINGS_WITH_CATEGORY, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  fromDate: (0, _moment["default"])().startOf("year").format(_dateTypes.DATE_TIME_TYPE),
  toDate: (0, _moment["default"])().endOf('day').format(_dateTypes.DATE_TIME_TYPE),
  reportType: _reportConsts.REPORT_TYPE.WARNINGS_WITH_CATEGORY,
  warningCategoryReportType: 'LIB.6328886.816.1240045.175'
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.PRODUCT_DATA_HISTORY_EMAIL_WARNINGS, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  fromDate: (0, _moment["default"])().startOf("year").format(_dateTypes.DATE_TIME_TYPE),
  toDate: (0, _moment["default"])().endOf('day').format(_dateTypes.DATE_TIME_TYPE),
  reportType: _reportConsts.REPORT_TYPE.PRODUCT_HISTORY_EMAIL_WARNINGS,
  warningCategoryReportType: 'LIB.3440978.917.4133582.505'
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.PRODUCT_DATA_ALL_WARNINGS, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  fromDate: (0, _moment["default"])().startOf("year").format(_dateTypes.DATE_TIME_TYPE),
  toDate: (0, _moment["default"])().endOf('day').format(_dateTypes.DATE_TIME_TYPE),
  reportType: _reportConsts.REPORT_TYPE.PRODUCT_STATUS_ALL_WARNINGS,
  warningCategoryReportType: 'LIB.3440978.917.4133582.505'
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.BUSINESS_SUMMARY_ALL_WARNINGS, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  fromDate: (0, _moment["default"])().startOf("year").format(_dateTypes.DATE_TIME_TYPE),
  toDate: (0, _moment["default"])().endOf('day').format(_dateTypes.DATE_TIME_TYPE),
  reportType: _reportConsts.REPORT_TYPE.PRODUCT_STATUS_ALL_WARNINGS,
  warningCategoryReportType: 'LIB.8677345.445.5902754.955'
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.BUSINESS_SUMMARY_HISTORY_EMAIL_WARNINGS, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  fromDate: (0, _moment["default"])().startOf("year").format(_dateTypes.DATE_TIME_TYPE),
  toDate: (0, _moment["default"])().endOf('day').format(_dateTypes.DATE_TIME_TYPE),
  reportType: _reportConsts.REPORT_TYPE.PRODUCT_HISTORY_EMAIL_WARNINGS,
  warningCategoryReportType: 'LIB.8677345.445.5902754.955'
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.OPENED_INVOICE_FULL, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  fromDate: (0, _moment["default"])().startOf("year").format(_dateTypes.DATE_TIME_TYPE),
  toDate: (0, _moment["default"])().endOf('day').format(_dateTypes.DATE_TIME_TYPE),
  reportType: _reportConsts.REPORT_TYPE.OPENED_INVOICE_FULL
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.HISTORY_INVOICE_FULL, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  reportType: _reportConsts.REPORT_TYPE.HISTORY_INVOICE_FULL
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.MEDIA_SOLUTIONS, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  fromDate: (0, _moment["default"])().startOf("year").format(_dateTypes.DATE_TIME_TYPE),
  toDate: (0, _moment["default"])().endOf('day').format(_dateTypes.DATE_TIME_TYPE),
  reportType: _reportConsts.REPORT_TYPE.MEDIA_SOLUTIONS
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.MEDIA_BLOCKED_GRAPH, _objectSpread({}, COMMON_FILTER_DEFAULTS, (_objectSpread21 = {
  fromDate: (0, _moment["default"])().subtract(30, "day").startOf("day").format(_dateTypes.DATE_TIME_TYPE),
  toDate: (0, _moment["default"])().endOf('day').format(_dateTypes.DATE_TIME_TYPE)
}, _defineProperty(_objectSpread21, FILTER_FIELD.GROUP_TIME_BY, 'daily'), _defineProperty(_objectSpread21, "reportType", _reportConsts.REPORT_TYPE.PRODUCT_STATUS_GRAPH), _objectSpread21))), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.SUMMARY_WAREHOUSE_CHART, COMMON_FILTER_DEFAULTS), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.SUMMARY_WAREHOUSE_CUMULATIVE, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  currency: defaultCurrency
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.PAYMENT_SUMMARY, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  fromDate: (0, _moment["default"])().startOf("year").format(_dateTypes.DATE_TIME_TYPE),
  toDate: (0, _moment["default"])().endOf('day').format(_dateTypes.DATE_TIME_TYPE),
  reportType: _reportConsts.REPORT_TYPE.PAYMENT_SUMMARY
})), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.PAYMENT_TRANSACTIONS, _objectSpread({}, COMMON_FILTER_DEFAULTS, {
  fromDate: (0, _moment["default"])().startOf("year").format(_dateTypes.DATE_TIME_TYPE),
  toDate: (0, _moment["default"])().endOf('day').format(_dateTypes.DATE_TIME_TYPE),
  reportType: _reportConsts.REPORT_TYPE.ALL_TRANSACTION
})), _defineProperty(_FILTER_DEFAULTS, "commonOrdersSecondaryChart", COMMON_FILTER_DEFAULTS), _defineProperty(_FILTER_DEFAULTS, "multiSortField", {
  selected: false
}), _defineProperty(_FILTER_DEFAULTS, "productStatusPieChart", COMMON_FILTER_DEFAULTS), _defineProperty(_FILTER_DEFAULTS, "openTaskHistoryPieChart", COMMON_FILTER_DEFAULTS), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.ARTICLES_CREATION, _objectSpread({}, COMMON_FILTER_DEFAULTS, _defineProperty({}, FILTER_FIELD.GROUP_TIME_BY, 'daily'))), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.VALUE_GROUP_ANALYSIS, _defineProperty({}, FILTER_FIELD.REPORT_TYPE, _reportConsts.REPORT_TYPE.VALUE_GROUP_ANALYSIS)), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.TEMPLATE_ANALYSIS_OVERVIEW, _objectSpread({}, COMMON_FILTER_DEFAULTS, _defineProperty({}, FILTER_FIELD.REPORT_TYPE, _reportConsts.REPORT_TYPE.TEMPLATE_ANALYSIS_OVERVIEW))), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.TEMPLATE_ANALYSIS_PARTNER_DETAILS, _objectSpread({}, COMMON_FILTER_DEFAULTS, _defineProperty({}, FILTER_FIELD.REPORT_TYPE, _reportConsts.REPORT_TYPE.TEMPLATE_ANALYSIS_PARTNER_DETAILS))), _defineProperty(_FILTER_DEFAULTS, FILTER_TYPE.COMMON_ORDERS_DATES, {
  fromDate: (0, _moment["default"])().startOf("month").format(_dateTypes.DATE_TIME_TYPE),
  toDate: (0, _moment["default"])().endOf('day').format(_dateTypes.DATE_TIME_TYPE)
}), _FILTER_DEFAULTS); // TODO: remove first slash in url after refactor all api requests

exports.FILTER_DEFAULTS = FILTER_DEFAULTS;
var FILTER_URLS = {
  COCKPIT_CHANNEL_CURRENCY_URL: 'cockpit/channel-currency',
  CHANNEL_RELATED_CUMULATIVE_URL: 'filter/channels-related-cumulative',
  PARTNER_RELATED_CUMULATIVE_URL: 'filter/partners-related-cumulative',
  CHANNEL_RELATED_URL: 'filter/channels-related',
  PARTNER_RELATED_URL: 'filter/partners-related',
  ARTICLE_RELATED_URL: 'filter/articles-related',
  CHANNEL_RELATED_GRAPH_URL: 'filter/channels-related-graph',
  PARTNER_RELATED_GRAPH_URL: 'filter/partners-related-graph',
  PARTNER_WARNINGS_CATEGORY_URL: 'filter/warnings-category/partners-related',
  PRODUCT_STATUS_CHANNEL_CUMULATIVE_URL: 'filter/product-status/channels-related-cumulative',
  PRODUCT_STATUS_PARTNER_CUMULATIVE_URL: 'filter/product-status/partners-related-cumulative',
  PRODUCT_STATUS_CHANNEL_URL: 'filter/product-status/channels-related',
  PRODUCT_STATUS_PARTNER_URL: 'filter/product-status/partners-related',
  PRODUCT_STATUS_WARNINGS_TYPE_URL: 'filter/product-status/warnings/types',
  PRODUCT_STATUS_WARNINGS_REPORT_TYPE_URL: 'filter/product-status/warnings/report-types',
  PRODUCT_STATUS_WARNINGS_LEVEL_URL: 'filter/product-status/warnings/levels',
  PRODUCT_STATUS_WARNINGS_BRAND_URL: 'productStatus/warnings/all-warnings/filter/brands',
  PRODUCT_STATUS_WARNINGS_SEASON_URL: 'productStatus/warnings/all-warnings/filter/seasons',
  PRODUCT_STATUS_ALL_WARNINGS_TYPE_URL: 'productStatus/warnings/all-warnings/filter/types',
  PRODUCT_STATUS_WARNINGS_PRODUCT_ID_URL: 'filter/product-status/warnings/product-id',
  PRODUCT_STATUS_WARNINGS_ARTICLE_ID_URL: 'filter/product-status/warnings/article-id',
  PRODUCT_EMAIL_REPORT_TYPE_URL: 'productStatus/warnings/all-warnings/filter/email-report-types',
  PRODUCT_STATUS_WARNINGS_HELP_URL: 'productStatus/warnings/help',
  PRODUCT_CHANNEL_URL: 'filter/product/channels-related',
  PRODUCT_PARTNER_URL: 'filter/product/partners-related',
  ARCHIVE_TYPE_URL: 'archived-articles/filter/types',
  ARCHIVE_LEVEL_URL: 'archived-articles/filter/levels',
  ARCHIVE_BRAND_URL: 'archived-articles/filter/brands',
  ARCHIVE_SEASON_URL: 'archived-articles/filter/seasons',
  MEDIA_BLOCKED_GRAPH_URL: 'media-graph-data/charts',
  MEDIA_SOLUTIONS_BRAND_URL: 'media/solutions/filter/brands',
  MEDIA_SOLUTIONS_SEASON_URL: 'media/solutions/filter/seasons',
  ORDER_STATISTICS_CHANNELS_URL: 'order-statistics/filter/channels',
  ORDER_STATISTICS_PARTNERS_URL: 'order-statistics/filter/partners',
  ORDER_STATISTICS_WAREHOUSES_URL: 'order-statistics/filter/warehouses',
  ORDER_STATISTICS_BRANDS_URL: 'order-statistics/filter/brands',
  CHANNEL_URL: 'filter/channels',
  PARTNER_URL: 'filter/partners',
  BRANDS_URL: 'filter/brands',
  EMAIL_NOTIFICATION_TYPE_URL: 'filter/emailNotificationType',
  WAREHOUSE_URL: 'filter/warehouses',
  RETURN_WAREHOUSE_URL: 'filter/return-warehouses',
  CURRENCY_URL: 'filter/currencies',
  PRODUCT_STATUSES: 'filter/productStatuses',
  REASONS: 'filter/',
  SALES_CHANNEL_RELATED_URL: 'filter/sales/channels-related',
  SALES_BRAND_RELATED_URL: 'filter/sales/brands-related',
  SALES_WAREHOUSE_RELATED_URL: 'filter/sales/warehouses-related',
  CANCEL_REASONS_URL: 'filter/cancelReasons',
  RETURN_REASONS_URL: 'filter/returnReasons',
  COUNTING_MODE_URL: 'filter/counting_modes',
  SUMMARY_WAREHOUSE_CUMULATIVE_PARTNER_URL: 'summary-warehouse/cumulative/filter/partners',
  SUMMARY_WAREHOUSE_CUMULATIVE_WAREHOUSE_URL: 'summary-warehouse/cumulative/filter/warehouses',
  SUMMARY_WAREHOUSE_CHART_WAREHOUSE_URL: 'summary-warehouse/chart/filter/warehouses',
  SUMMARY_WAREHOUSE_CHART_OWNER_PARTNER_URL: 'summary-warehouse/chart/filter/owner-partners',
  SUMMARY_WAREHOUSE_CHART_SERVED_PARTNER_URL: 'summary-warehouse/chart/filter/served-partners',
  OPENED_ORDER_CHANNEL_URL: 'orders/opened/confirmations/filter/channel',
  OPENED_ORDER_PARTNER_URL: 'orders/opened/confirmations/filter/partner',
  RETURN_REASON_CUMULATIVE_URL: 'orders/return/cumulative/reasons',
  RETURN_REASON_URL: 'orders/return/full/reasons',
  RETURN_CONDITION_CUMULATIVE_URL: 'orders/return/cumulative/return_conditions',
  RETURN_CONDITION_URL: 'orders/return/full/return_conditions',
  START_HUB_RELATED_URL: 'filter/start-hubs-related',
  TARGET_HUB_RELATED_URL: 'filter/target-hubs-related',
  USERS_URL: 'filter/dashboard-users'
};
exports.FILTER_URLS = FILTER_URLS;
var UPPER_FILTERS_ALLOWED_TABS = ['chart', 'cockpit', 'sales'];
exports.UPPER_FILTERS_ALLOWED_TABS = UPPER_FILTERS_ALLOWED_TABS;
var GROUP_TIME_BY_OPTIONS_WITH_HOURS = [{
  id: 'hourly',
  name: 'filter/groupTimeBy/hourly'
}, {
  id: 'daily',
  name: 'filter/groupTimeBy/daily'
}, {
  id: 'weekly',
  name: 'filter/groupTimeBy/weekly'
}, {
  id: 'monthly',
  name: 'filter/groupTimeBy/monthly'
}, {
  id: 'quarterly',
  name: 'filter/groupTimeBy/quarterly'
}, {
  id: 'yearly',
  name: 'filter/groupTimeBy/yearly'
}, {
  id: 'total',
  name: 'filter/groupTimeBy/total'
}];
exports.GROUP_TIME_BY_OPTIONS_WITH_HOURS = GROUP_TIME_BY_OPTIONS_WITH_HOURS;
var GROUP_BY_ITEM_OPTIONS = [{
  id: "product",
  name: 'filter/groupItemBy/product'
}, {
  id: "articleColor",
  name: 'filter/groupItemBy/articleColor'
}, {
  id: "article",
  name: 'filter/groupItemBy/article'
}];
exports.GROUP_BY_ITEM_OPTIONS = GROUP_BY_ITEM_OPTIONS;
var GROUP_TIME_BY_OPTIONS = [{
  id: 'daily',
  name: 'filter/groupTimeBy/daily'
}, {
  id: 'weekly',
  name: 'filter/groupTimeBy/weekly'
}, {
  id: 'monthly',
  name: 'filter/groupTimeBy/monthly'
}, {
  id: 'quarterly',
  name: 'filter/groupTimeBy/quarterly'
}, {
  id: 'yearly',
  name: 'filter/groupTimeBy/yearly'
}, {
  id: 'total',
  name: 'filter/groupTimeBy/total'
}];
exports.GROUP_TIME_BY_OPTIONS = GROUP_TIME_BY_OPTIONS;
var GROUP_TIME_BY_OPTIONS_WITHOUT_TOTAL = [{
  id: 'daily',
  name: 'filter/groupTimeBy/daily'
}, {
  id: 'weekly',
  name: 'filter/groupTimeBy/weekly'
}, {
  id: 'monthly',
  name: 'filter/groupTimeBy/monthly'
}, {
  id: 'quarterly',
  name: 'filter/groupTimeBy/quarterly'
}, {
  id: 'yearly',
  name: 'filter/groupTimeBy/yearly'
}];
exports.GROUP_TIME_BY_OPTIONS_WITHOUT_TOTAL = GROUP_TIME_BY_OPTIONS_WITHOUT_TOTAL;
var ESCALATION_OPTIONS = [{
  id: '1',
  name: 'sla/escalation/level1'
}, {
  id: '2',
  name: 'sla/escalation/level2'
}, {
  id: '3',
  name: 'sla/escalation/level3'
}];
exports.ESCALATION_OPTIONS = ESCALATION_OPTIONS;
var ESCALATION_OPTIONS_DESCRIPTION = [{
  id: '1',
  name: 'Level 1'
}, {
  id: '2',
  name: 'Level 2'
}, {
  id: '3',
  name: 'Level 3'
}];
exports.ESCALATION_OPTIONS_DESCRIPTION = ESCALATION_OPTIONS_DESCRIPTION;
var RETURN_ESCALATION_OPTIONS_DESCRIPTION = [{
  id: '1',
  name: 'openReturnOrders/TableView/escalation_1'
}, {
  id: '2',
  name: 'openReturnOrders/TableView/escalation_2'
}, {
  id: '3',
  name: 'openReturnOrders/TableView/escalation_3'
}, {
  id: 'DHLDE',
  name: 'openReturnOrders/TableView/escalation_DHLDE'
}];
exports.RETURN_ESCALATION_OPTIONS_DESCRIPTION = RETURN_ESCALATION_OPTIONS_DESCRIPTION;
var EDITING_STATUS_OPTIONS = [{
  id: 'OPEN',
  name: 'Open'
}, {
  id: 'IN_PROGRESS',
  name: 'In Progress'
}, {
  id: 'DONE',
  name: 'Done'
}];
exports.EDITING_STATUS_OPTIONS = EDITING_STATUS_OPTIONS;
var SLA_OPTIONS = [{
  id: '1',
  name: 'SLA1'
}, {
  id: '2',
  name: 'SLA2'
}, {
  id: '3',
  name: 'SLA3'
}, {
  id: '4',
  name: 'FAILED'
}];
exports.SLA_OPTIONS = SLA_OPTIONS;
var GROUP_ITEM_BY = [{
  id: 'channel',
  name: 'filter/groupItemBy/channel'
}, {
  id: 'partner',
  name: 'filter/groupItemBy/partner'
}];
exports.GROUP_ITEM_BY = GROUP_ITEM_BY;
var TRANSACTION_TYPE_OPTIONS = [{
  id: 'CREDIT',
  name: 'AllTransactions/PaymentType/Credit'
}, {
  id: 'DEBIT',
  name: 'AllTransactions/PaymentType/Debit'
}, {
  id: 'PAYOUT',
  name: 'AllTransactions/PaymentType/Payout'
}];
exports.TRANSACTION_TYPE_OPTIONS = TRANSACTION_TYPE_OPTIONS;
var FILTER_FORM_SETTINGS = {
  isFilterFormHidden: _Utils["default"].getOrientation() === 'portrait'
};
exports.FILTER_FORM_SETTINGS = FILTER_FORM_SETTINGS;
var SLA_SENT_ORDERS_DELIVERY_OPTIONS = [{
  id: '1',
  name: 'SLA1 < 24H'
}, {
  id: '2',
  name: 'SLA2 < 48H'
}, {
  id: '3',
  name: 'SLA3 < 72H'
}, {
  id: '4',
  name: 'FAIL > 72H'
}, {
  id: '5',
  name: 'Pick-up SLA < 12H'
}, {
  id: '6',
  name: 'Pick-up FAIL > 12H'
}];
exports.SLA_SENT_ORDERS_DELIVERY_OPTIONS = SLA_SENT_ORDERS_DELIVERY_OPTIONS;
var SLA_SENT_ORDERS_UNCONFIRMED_OPTIONS = [{
  id: '1',
  name: 'Pick-up SLA1 < 12h'
}, {
  id: '2',
  name: 'Pick-up FAIL > 12h'
}];
exports.SLA_SENT_ORDERS_UNCONFIRMED_OPTIONS = SLA_SENT_ORDERS_UNCONFIRMED_OPTIONS;